import { render } from "./SubscribeInfo.vue?vue&type=template&id=23a3dd04"
import script from "./SubscribeInfo.vue?vue&type=script&lang=js"
export * from "./SubscribeInfo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__